import { ContactUsCombinedProps } from './types';

const usePresenter = (props: ContactUsCombinedProps): ContactUsCombinedProps => {
  return props;
};

export default usePresenter;
